<template>
  <div style="min-height: 100vh; background: #f4f6fa">
    <pcHeaders></pcHeaders>
    <div style="width: 100%; display: flex; justify-content: center; background-color: #fff; margin-top: 12px">
      <div class="banner">
        <div class="section">
          <div style="display: flex; justify-content: space-between">
            <div class="hen" style="margin-bottom: 20px; align-items: center">
              <div style="margin-right: 0; font-size: 14px; height: 25px; line-height: 25px; width: 80px">分类搜索：</div>
              <div class="searBoxs">
                <input type="text" class="sear" v-model="queryParams.searchText" placeholder="搜索你想要的关键词" />
                <div class="ss" @click="handlSear">搜索</div>

                <div class="seletClass"></div>
              </div>
            </div>
          </div>
          <div class="hen">
            <div style="margin-right: 0; font-size: 14px; height: 25px; line-height: 25px; width: 80px">选择类别：</div>
            <div class="seBox">
              <div :class="tabActive == 0 ? 'selet1 seletActive1' : 'selet1'" @click="allSeleted">全部</div>
              <div
                :class="tabActive == index + 1 ? 'selet1 seletActive1' : 'selet1'"
                v-for="(item, index) in codeList"
                :key="item.id"
                @click="seletNav(item, index)"
              >
                {{ item.codeName }}
              </div>
            </div>
          </div>

          <div class="category" v-for="item in seList" :key="item.id">
            <div class="cName">{{ item.codeName }}</div>
            <div class="courseBox">
              <div class="caList" @click="goSubmit(v)" v-for="v in item.children" :key="v.id">
                <div class="cover">
                  <img :src="v.codeDesc" alt="" v-if="v.codeDesc != null && v.codeDesc != ''" />
                  <img src="../../assets/images/noImg.jpg" alt="" v-else />
                </div>
                <div class="info">
                  <div class="text_7">{{ v.codeName }}</div>
                  <div class="text_8">
                    <span class="registration" @click="goSubmit(v)">立即报名</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="caList">
              <div class="caBox"  @click="goSubmit(v)" v-for="v in item.children" :key="v.id">
                <div class="ca1">{{ v.codeName }}</div>
                <div class="ca2">
                  <div>点击报名</div>
                  <div class="caImg"></div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <pcBottom></pcBottom>
    <!-- <flotRight /> -->
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import pcHeaders from '../component/head.vue';
import pcBottom from '../component/bottom.vue';
import { search, codeListBySpotId } from '@/api/courseSelection.js';
import flotRight from '@/views/component/flotRight.vue';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    pcHeaders,
    pcBottom,
    flotRight
  },
  data() {
    // 这里存放数据
    return {
      tab1: 0, //选中
      tab2: 0,
      tab3: '',
      queryParams: {
        pageNum: 1,
        pageSize: 1000,
        className: ''
      },
      total: 0,
      codeList: [],
      seList: [], //筛选后的list
      tabActive: 0 //0全部
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    '$route.query.type'(newType) {
      if (newType !== undefined) {
        this.autoSelectByType(newType);
      }
    }
  },
  // 方法集合
  methods: {
    //点击全部
    allSeleted() {
      this.queryParams.searchText = '';
      this.tabActive = 0;
      this.seList = this.codeList;
    },
    //选中分类
    seletNav(item, index) {
      console.log(item);
      this.queryParams.searchText = '';
      this.seList = [item];
      this.tabActive = index + 1;
    },
    goSubmit(item) {
      this.$router.push({
        path: '/submit',
        query: {
          id: item.cid,
          codeName: item.codeName,
          parentId: item.parentId,
          trainIndustry: item.trainIndustry
        }
      });
    },
    //选择搜索种类
    handSelet(id) {
      this.searType = id;
      if (id == '1') {
        this.searShowText = '班级';
      } else {
        this.searShowText = '分类';
      }
      this.showSearFlag = false;
    },
    //重置搜索
    clerSear() {
      this.queryParams.pageNum = 1;
      this.queryParams.pageSize = 1000;
      this.tab1 = 0;
      this.getClassList();
    },
    //搜索课程
    handlSear() {
      search(this.queryParams).then(res => {
        console.log(res);
        this.tabActive = 0;
        this.seList = [
          {
            codeName: '搜索结果',
            children: res.data.rows
          }
        ];
      });
    },
    handleUpdate(newValue) {
      this.queryParams.codeNo = newValue.localValue;
      this.queryParams.className = newValue.className;
      this.queryParams.pageNum = 1;
      this.queryParams.pageSize = 10;
      this.tab1 = null;
      this.tab2 = null;
      this.tab3 = null;
      this.getClassList();
    },
    getList() {
      codeListBySpotId().then(res => {
        console.log(res.data.data);
        this.codeList = res.data.data;
        this.seList = this.codeList;
        const routeType = this.$route.query.type;
        if (routeType) {
          this.autoSelectByType(routeType);
        }
      });
    },
    autoSelectByType(type) {
      if (!type || !this.codeList.length) return;
      // 查找 codeNo 匹配的项
      const matchedItem = this.codeList.find(item => item.codeNo === type);
      if (matchedItem) {
        const index = this.codeList.indexOf(matchedItem);
        this.tabActive = index + 1;
        this.seList = [matchedItem];
      } else {
        this.tabActive = 0;
        this.seList = this.codeList;
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getList();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.banner {
  margin-top: 20px;
  font-family: Regular;
  display: flex;
  width: 1400px;
  padding: 25px 0px;
  min-height: 720px;
  margin-bottom: 20px;
  background: #fff;
  .section {
    .hen {
      display: flex;
      align-items: center;
      .searBoxs {
        width: 380px;
        height: 46px;
        position: relative;
        .seletClass {
          position: absolute;
          top: 0;
          height: 46px;
          left: 20px;
          color: #4076f6;
          display: flex;
          align-items: center;
          cursor: pointer;
          font-size: 14px;
          .showBox {
            position: absolute;
            bottom: -55px;
            left: -15px;
            width: 59px;
            height: 64px;
            background: #ecf1fe;
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
            border-radius: 6px 6px 6px 6px;
            div {
              width: 100%;
              height: 32px;
              text-align: center;
              line-height: 32px;
              color: #333;
            }
          }
          .su {
            width: 1px;
            height: 16px;
            background: #d6d6d6;
            margin-left: 13px;
          }
        }
        .sear {
          width: 380px;
          height: 46px;
          background: rgba(64, 118, 246, 0.1);
          border-radius: 25px;
          color: #8a8a8a;
          padding-left: 20px;
          padding-right: 90px;
          border: 0 !important;
        }
        .ss {
          text-align: center;
          line-height: 36px;
          width: 76px;
          height: 36px;
          background: #4076f6;
          border-radius: 21px 21px 21px 21px;
          background: #4076f6;
          border: 1px solid #4076f6;
          color: #fff;
          position: absolute;
          right: 5px;
          top: 5px;
          cursor: pointer;
          font-size: 14px;
        }
      }
      .seBox {
        display: flex;
      }
      .selet1 {
        height: 40px;
        border-radius: 20px 20px 20px 20px;
        border: 1px solid #3172f6;
        padding: 0 30px;
        line-height: 40px;
        color: #3172f6;
        font-size: 16px;
        cursor: pointer;
        margin-right: 30px;
      }
      .selet1:hover {
        background: #3172f6;
        color: #fff;
      }
      .seletActive1 {
        background: #3172f6;
        color: #fff;
      }
      .selet {
        // width: 120px;
        padding: 0 16px;
        margin-top: 2px;
        font-size: 14px;
        margin-right: 7px;
        cursor: pointer;
        height: 25px;
        line-height: 25px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        border-radius: 12px;
        color: #666;
      }
      .selet:hover {
        background: rgba(64, 118, 246, 0.1);
        color: #4076f6;
      }
      .seletActive {
        background: rgba(64, 118, 246, 0.1);
        color: #4076f6;
      }
    }

    .category {
      margin-top: 40px;
      .cName {
        font-weight: bold;
        font-size: 20px;
        color: #333333;
      }
      .courseBox {
        display: flex;
        flex-wrap: wrap;
      }
      .caList:nth-child(6n) {
        margin-right: 0 !important;
      }
      .caList {
        box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
        border-radius: 10px 10px 10px 10px;
        width: 220px;
        margin-right: 16px;
        height: 186px;
        background: #f4f6fa;
        border-radius: 10px 10px;
        position: relative;
        display: flex;
        margin-top: 16px;
        flex-wrap: wrap;

        .cover {
          border-radius: 10px;
          width: 220px;
          height: 176px;
        }
        .cover img {
          border-radius: 10px;
          width: 220px;
          height: 176px;
        }
        .info {
          background-color: #fff;
          position: absolute;
          bottom: 0px;
          left: 0;
          right: 0;
          width: 220px;
          padding: 8px 10px;
          border-radius: 0px 0px 10px 10px;

          height: 80px;
          .text_7 {
            width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #000000;
          }
          .text_8 {
            margin-top: 10px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
          }
          .registration {
            cursor: pointer;

            display: flex;
            align-items: center;
            justify-content: center;
            width: 88px;
            height: 32px;
            background: rgba(49, 114, 246, 0.1);
            border-radius: 16px 16px 16px 16px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #3172f6;
          }
        }
        // .caBox {
        //   align-self: flex-start; /* 单独设为顶部对齐，不影响其他 */
        //   width: 210px;
        //   min-height: 80px;
        //   background: #edf2f8;
        //   border-radius: 4px 4px 4px 4px;
        //   padding: 15px 20px;
        //   cursor: pointer;
        //   margin-right: 18px;
        //   margin-bottom: 10px;
        //   .ca1 {
        //     font-size: 16px;
        //     color: #333333;
        //   }
        //   .ca2 {
        //     margin-top: 8px;
        //     display: flex;
        //     color: #3172f6;
        //     font-size: 14px;
        //     align-items: center;
        //     .caImg {
        //       background: url('../../assets/listImgs/jtIcon@2x.png');
        //       width: 16px;
        //       height: 16px;
        //       margin-left: 2px;
        //       background-repeat: no-repeat;
        //       background-position: center;
        //       background-size: contain; /* 关键：完整显示图片 */
        //     }
        //   }
        // }
        // .caBox:hover {
        //   background: #3172f6;
        //   .ca1 {
        //     color: #fff !important;
        //   }
        //   .ca2 {
        //     color: #fff;
        //   }
        //   .caImg {
        //     background: url('../../assets/listImgs/hoverJt@2x.png');
        //     width: 16px;
        //     height: 16px;
        //     margin-left: 2px;
        //     background-repeat: no-repeat;
        //     background-position: center;
        //     background-size: contain; /* 关键：完整显示图片 */
        //   }
        // }
        // .caBox:nth-child(6n) {
        //   margin-right: 0 !important;
        // }
      }
    }
  }
}
</style>
